import {
    ControllerBase
} from "./base";

const gameCycleTime = 2 * 1000;

const speeds = [
    100,
    200,
    400,
    800
]

const token = "12b43e62-d36b-4ff8-ae1e-3eec4565c1cd";

const outcomes = {
    prize: "Prize",
    booby: "Booby",
};

const outcomeSources = {
    booby: "assets/images/IntroBooby.webm",
    prize: "assets/images/IntroPrize.webm",
}

class _GameController extends ControllerBase {
    currentSpeed = 0;
    currentPrizeIdx = 0;
    currentPrize = null;
    winningPrizeIdx = 0;
    playerIdentifier = null;
    gamePlayerID = null;
    canPlay = false;
    gameConfig = null;
    errorText = "";
    showOutcome = false;
    outcome = null;
    outcomeSrc = "";
    loopingSrc = "";
    showLooping = false;
    winningPrize = null;
    showClose = false;
    playAudio = false;

    constructor() {
        super();

        getTokenStatus(this, token, () => {
            if (this.playerIdentifier != undefined && this.playerIdentifier != null && this.playerIdentifier != "") {
                if (this.ctx.$route.path != '/') {
                    this.ctx.$router.push('/')
                }
            }
        });
    }

    verifyPlayer() {
        setTimeout(() => {
            verifyPlayer(this, () => {
                this.startGame();
            });
        }, 500);
    }

    startGame() {
        getTokenStatus(this, token, gameConfig => {
            var currentRound = gameConfig.currentRound;

            if (currentRound > 0) {
                getRoundOutcome(this);
            } else {
                alert("Please wait for the game to start");
            }
        })
    }

    spinWheel() {
        this.playAudio = true;

        setTimeout(() => {
            cycleToComplete(this, () => {
                let prizes = this.ctx.ctrl_prize().prizes;
    
                this.currentPrizeIdx = prizes.indexOf(this.winningPrize);
                this.currentPrize = this.winningPrize;
    
                setTimeout(() => {
                    this.showOutcome = true;
    
                    setTimeout(() => {
                        this.showClose = true;
                    }, 10000);
                }, 4000);
            })
        }, 500);
    }

    setLooping() {
        this.showLooping = true;
    }

    resetGame() {
        setTimeout(() => {
            this.canPlay = false;
            window.location.reload();
        }, 500);
    }
}

function verifyPlayer(ctrl, callback) {
    ctrl.errorText = "";

    ctrl.serviceCaller.call(
            ctrl.serviceCaller.methods.get,
            `Play/Tokaly/GamePlayer/Verify?identifier=${ctrl.playerIdentifier}&gameID=${ctrl.gameConfig.id}`
        )
        .then(response => {
            if (response > 0) {
                // localStorage.setItem("playerIdentifier", ctrl.playerIdentifier);
                // localStorage.setItem("gamePlayerID", response);
                ctrl.gamePlayerID = response;
                ctrl.canPlay = true;
            } else {
                ctrl.canPlay = false;
                ctrl.errorText = "Please provide a valid phone number";
            }

            callback()
        })
}

function getTokenStatus(ctrl, token, callback) {
    ctrl.serviceCaller.call(
            ctrl.serviceCaller.methods.get,
            `Tokaly/GameUrlLink/TokenStatus?token=${token}`
        )
        .then(response => {
            getGameConfig(ctrl, response.gameUID, callback)
        })
        .catch(e => {
            alert("THERE WAS AN ERROR GETTING THE TOKEN STATUS: " + e)
        })
}

function getGameConfig(ctrl, gameUID, callback) {
    ctrl.serviceCaller.call(
            ctrl.serviceCaller.methods.get,
            `Play/Tokaly/Games/GetGame?gameUID=${gameUID}`
        )
        .then(response => {
            ctrl.gameConfig = response;
            ctrl.ctx.ctrl_prize().setPrizes(response.gamePrizes);
            callback(response)
        })
        .catch(e => {
            alert("THERE WAS AN ERROR GETTING THE GAME CONFIG: " + e)
        })
}

function cycleToComplete(ctrl, callback) {
    cyclePrizes(ctrl, speeds[ctrl.currentSpeed], gameCycleTime, () => {
        if (ctrl.currentSpeed + 1 == speeds.length) {
            callback();
        } else {
            ctrl.currentSpeed++;
            cycleToComplete(ctrl, callback);
        }
    })
}

function cyclePrizes(ctrl, speed, cycleTime, callback) {
    let prizes = ctrl.ctx.ctrl_prize().prizes;

    let interval = setInterval(() => {
        if (ctrl.currentPrizeIdx + 1 >= prizes.length) {
            ctrl.currentPrizeIdx = 0;
        } else {
            ctrl.currentPrizeIdx++;
        }

        ctrl.currentPrize = prizes[ctrl.currentPrizeIdx];
    }, speed);

    let timer = setTimeout(() => {
        clearTimeout(timer);
        clearInterval(interval);
        callback();
    }, cycleTime);
}

function getRoundOutcome(ctrl) {
    ctrl.serviceCaller.call(
            ctrl.serviceCaller.methods.get,
            `Play/Tokaly/Game/RoundOutcome?gameID=${ctrl.gameConfig.id}&gamePlayerID=${ctrl.gamePlayerID}&round=${ctrl.gameConfig.currentRound}`
        )
        .then(response => {
            if (response == null) {
                console.log("Response null");
            } else {
                ctrl.outcome = response;

                console.log("Outcome", response)

                ctrl.ctx.$router.push('/play');

                if(window.innerWidth < 600) {
                    openFullscreen();
                }

                let prizes = ctrl.ctx.ctrl_prize().prizes;

                if (ctrl.outcome.won) {
                    ctrl.winningPrize = prizes.find(prize => {
                        return prize.id == ctrl.outcome.prizeID
                    });

                    ctrl.outcome = outcomes.prize;
                    ctrl.outcomeSrc = outcomeSources.prize;
                    ctrl.loopingSrc = ctrl.winningPrize.videoSrc;
                } else {
                    ctrl.winningPrize = prizes[prizes.length - 1];
                    ctrl.outcome = outcomes.booby;
                    ctrl.outcomeSrc = "assets/images/Boobie Trap Loop.webm";
                    ctrl.loopingSrc = "assets/images/Boobie Trap Loop.webm";
                }
            }
        })
}

document.addEventListener("orientationchange", function(){
    switch(window.orientation) 
    {  
        case -90: case 90:
            /* Device is in landscape mode */
            break; 
        default:
            /* Device is in portrait mode */
    }
});

function openFullscreen() {
    if (document.body.requestFullscreen) {
        document.body.requestFullscreen();
    } else if (document.body.webkitRequestFullscreen) { /* Safari */
        document.body.webkitRequestFullscreen();
    } else if (document.body.msRequestFullscreen) { /* IE11 */
        document.body.msRequestFullscreen();
    }
  }

export const GameController = new _GameController();